import { render, staticRenderFns } from "./ShiftDetailsSheetContent.vue?vue&type=template&id=4d083f4e&"
import script from "./ShiftDetailsSheetContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ShiftDetailsSheetContent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports